import React, { useEffect, useState } from 'react';
import { Check, ChevronDown, ChevronUp, ShieldCheck, Star, Lock, X, CheckCircle2, AlertTriangle, Zap, Brain, Target, Calendar } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
const IMG_MAIN = 'https://cdn.magicpatterns.com/uploads/8LAj76dG7Bis3ekTf9zeK6/MOCKUP_PRINCIPAL.png';
const IMG_BONUS_1 = 'https://cdn.magicpatterns.com/uploads/hck7KPAJue8mpC8w5Z9oNn/MOCKUP_BONO_1.png';
const IMG_BONUS_2 = 'https://cdn.magicpatterns.com/uploads/xs7WBoCBbdzQaZ44nFq4dX/MOCKUP_BONO_2.png';
const IMG_BONUS_3 = 'https://cdn.magicpatterns.com/uploads/tz9Uh4WmZS8fW98KjiumXr/MOCKUP_BONO_3.png';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/45932163039420:1';
const TESTIMONIALS = [{
  name: 'Julián Mendez',
  age: '28 años',
  role: 'Emprendedor',
  text: 'Sentía que trabajaba todo el día pero no avanzaba. Con el sistema de 7 etapas logré ordenar mi semana y por fin lancé mi proyecto personal. No es magia, es orden puro.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Carla Ricci',
  age: '32 años',
  role: 'Diseñadora Freelance',
  text: 'La procrastinación me estaba comiendo viva. El método anti-procrastinación fue un antes y un después. Ahora tengo claridad mental y disfruto mi tiempo libre sin culpa.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Esteban K.',
  age: '25 años',
  role: 'Estudiante y Empleado',
  text: 'Estaba en piloto automático total. Estudiar, trabajar, dormir. Este sistema me ayudó a reconectar con lo que quiero y a armar un plan real para conseguirlo.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Mariana Torres',
  age: '35 años',
  role: 'Gerente de Ventas',
  text: 'Simple, directo y aplicable. Nada de relleno motivacional barato. Herramientas concretas que apliqué desde el día 1. Vale cada centavo.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Lucas F.',
  age: '29 años',
  role: 'Programador',
  text: 'Necesitaba estructura, no ánimo. El sistema semanal estructurado me salvó del burnout. Recomendadísimo para cualquiera que se sienta estancado.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}];
const FAQS = [{
  q: '¿Es solo teoría?',
  a: 'No. Cada etapa incluye aplicación práctica diseñada para generar cambios inmediatos en tu rutina y mentalidad.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Está diseñado para empezar desde tu situación actual, sin importar tu nivel de conocimiento previo en desarrollo personal.'
}, {
  q: '¿Puedo hacerlo a mi ritmo?',
  a: 'Sí. El acceso es de por vida, por lo que podés avanzar a la velocidad que tu agenda permita.'
}, {
  q: '¿Es material digital?',
  a: 'Sí. Acceso y descarga inmediata a todo el sistema, guías y bonos apenas realizás la compra.'
}];
// Smooth scroll to offer section (1.5s)
function scrollToOffer(e: React.MouseEvent) {
  e.preventDefault();
  const target = document.getElementById('compra');
  if (!target) return;
  const start = window.scrollY;
  const end = target.getBoundingClientRect().top + window.scrollY;
  const duration = 1500;
  const startTime = performance.now();
  function step(now: number) {
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / duration, 1);
    // ease in-out cubic
    const ease = progress < 0.5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
    window.scrollTo(0, start + (end - start) * ease);
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
export function SalesPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  return <div className="font-sans text-gray-900" style={{
    backgroundColor: '#debdc8'
  }} data-id="element-21">
      <SocialProofPopup data-id="element-22" />

      {/* Top Bar - Urgency */}
      <div className="bg-[#2C1A20] text-white py-3 sticky top-0 z-40 shadow-md" data-id="element-23">
        <div className="container mx-auto px-4 flex justify-center items-center gap-4" data-id="element-24">
          <CountdownTimer data-id="element-25" />
          <span className="hidden md:inline font-bold text-[#debdc8]" data-id="element-26">
            🔥 CUPOS LIMITADOS
          </span>
        </div>
      </div>

      {/* Hero Section */}
      <header className="py-10 px-4" style={{
      backgroundColor: '#debdc8'
    }} data-id="element-27">
        <div className="max-w-4xl mx-auto text-center" data-id="element-28">
          <div className="inline-block bg-white/40 text-[#2C1A20] px-4 py-1 rounded-full font-bold text-sm md:text-base mb-4 border border-white/60" data-id="element-29">
            🔥 Para personas que sienten que están hechas para más… pero hoy se
            sienten estancadas
          </div>

          <h1 className="text-5xl md:text-7xl font-black text-[#2C1A20] mb-4 leading-tight uppercase font-heading tracking-tight" data-id="element-30">
            SISTEMA{' '}
            <span style={{
            color: '#7B4F3A'
          }} data-id="element-31">
              SALÍ DEL 99%
            </span>
          </h1>

          <div className="mb-6" data-id="element-32">
            <img src={IMG_MAIN} alt="Sistema Salí del 99% Pack Completo" className="w-full max-w-xl mx-auto drop-shadow-2xl" data-id="element-33" />
          </div>

          <p className="text-xl md:text-2xl text-[#2C1A20] mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-34">
            El método práctico de 7 etapas para{' '}
            <span className="font-bold bg-white/50 px-1 rounded" data-id="element-35">
              dejar de procrastinar
            </span>{' '}
            y empezar a construir tu mejor versión con estructura real en menos
            de 14 días.
          </p>

          <p className="text-lg font-semibold text-[#2C1A20]/70 mb-6" data-id="element-36">
            No es motivación. Es un proceso claro y aplicable.
          </p>

          <button onClick={scrollToOffer} className="inline-flex items-center justify-center text-[#2C1A20] text-2xl md:text-3xl font-black py-5 px-10 rounded-lg shadow-lg transition-all transform hover:-translate-y-1 w-full md:w-auto animate-pulse-slow border-2 border-[#2C1A20]/20" style={{
          backgroundColor: '#fff',
          color: '#2C1A20'
        }} data-id="element-37">
            👉 QUIERO EMPEZAR HOY
          </button>

          <div className="mt-3 flex justify-center items-center gap-2 text-sm text-[#2C1A20]/70" data-id="element-38">
            <ShieldCheck className="w-4 h-4 text-green-700" data-id="element-39" />
            <span data-id="element-40">Garantía de 7 días sin riesgo</span>
          </div>
        </div>
      </header>

      {/* Agitation / Problem Section */}
      <section className="py-8 px-4 bg-white" data-id="element-41">
        <div className="max-w-3xl mx-auto" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 font-heading text-[#2C1A20]" data-id="element-43">
            Si estás leyendo esto, probablemente te pasa algo así:
          </h2>

          <div className="p-6 rounded-2xl border-l-8 mb-6" style={{
          backgroundColor: '#f9f0f3',
          borderColor: '#debdc8'
        }} data-id="element-44">
            <p className="text-lg text-gray-700 mb-4" data-id="element-45">
              Cumplís con tus responsabilidades en piloto automático. Trabajás.
              Estudiás. Respondés.
            </p>
            <p className="text-lg text-gray-700 font-bold mb-3" data-id="element-46">
              Pero internamente sentís que:
            </p>
            <ul className="space-y-3" data-id="element-47">
              {['No estás creciendo.', 'Estás usando solo una parte de tu potencial.', 'Postergás decisiones importantes.', 'Sabés lo que deberías hacer… pero no lo hacés.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-48">
                  <div className="bg-red-100 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-49">
                    <X className="w-4 h-4 text-red-600" data-id="element-50" />
                  </div>
                  <span className="text-lg text-gray-800" data-id="element-51">{item}</span>
                </li>)}
            </ul>
            <p className="mt-4 text-lg font-medium italic" style={{
            color: '#7B4F3A'
          }} data-id="element-52">
              Y eso genera mucha frustración.
            </p>
          </div>

          <div className="text-center" data-id="element-53">
            <p className="text-xl text-gray-800" data-id="element-54">
              No porque seas incapaz. Sino porque{' '}
              <span className="font-bold underline decoration-4" style={{
              textDecorationColor: '#debdc8'
            }} data-id="element-55">
                no tenés una estructura personal
              </span>{' '}
              que te guíe en el camino.
            </p>
          </div>
        </div>
      </section>

      {/* The Real Problem — redesigned */}
      <section className="py-10 px-4" style={{
      backgroundColor: '#2C1A20'
    }} data-id="element-56">
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <div className="text-center mb-8" data-id="element-58">
            <h2 className="text-4xl md:text-5xl font-black font-heading uppercase mb-3" style={{
            color: '#debdc8'
          }} data-id="element-59">
              El problema real
            </h2>
            <p className="text-2xl font-light text-white/80" data-id="element-60">
              La mayoría vive{' '}
              <span className="font-bold text-white" data-id="element-61">reaccionando</span>.
            </p>
          </div>

          {/* Reaction cards */}
          <div className="grid grid-cols-3 gap-3 mb-8" data-id="element-62">
            {[{
            icon: '⚡',
            label: 'A obligaciones'
          }, {
            icon: '🔥',
            label: 'A urgencias'
          }, {
            icon: '👥',
            label: 'A lo que otros esperan'
          }].map((item, i) => <div key={i} className="rounded-xl p-4 text-center border border-white/10" style={{
            backgroundColor: 'rgba(222,189,200,0.12)'
          }} data-id="element-63">
                <div className="text-3xl mb-2" data-id="element-64">{item.icon}</div>
                <p className="text-white/80 text-sm font-medium" data-id="element-65">
                  {item.label}
                </p>
              </div>)}
          </div>

          <p className="text-center text-white/70 text-lg mb-6" data-id="element-66">
            Pero casi nadie aprende a:
          </p>

          {/* Skills grid */}
          <div className="grid md:grid-cols-2 gap-3 mb-8" data-id="element-67">
            {[{
            icon: <Brain className="w-5 h-5" data-id="element-68" />,
            text: 'Diseñar su identidad de forma consciente'
          }, {
            icon: <Zap className="w-5 h-5" data-id="element-69" />,
            text: 'Construir disciplina emocional'
          }, {
            icon: <AlertTriangle className="w-5 h-5" data-id="element-70" />,
            text: 'Eliminar la procrastinación'
          }, {
            icon: <Target className="w-5 h-5" data-id="element-71" />,
            text: 'Ordenar su mente'
          }, {
            icon: <Calendar className="w-5 h-5" data-id="element-72" />,
            text: 'Crear un sistema semanal personal'
          }].map((item, i) => <div key={i} className="flex items-center gap-3 rounded-lg px-4 py-3 border border-white/10" style={{
            backgroundColor: 'rgba(222,189,200,0.1)'
          }} data-id="element-73">
                <span style={{
              color: '#debdc8'
            }} data-id="element-74">
                  {item.icon}
                </span>
                <span className="text-white font-medium" data-id="element-75">{item.text}</span>
              </div>)}
          </div>

          <div className="rounded-xl p-6 text-center border" style={{
          backgroundColor: 'rgba(222,189,200,0.15)',
          borderColor: 'rgba(222,189,200,0.3)'
        }} data-id="element-76">
            <p className="text-2xl font-bold text-white mb-1" data-id="element-77">
              Sin estructura, dependés de la motivación.
            </p>
            <p className="text-xl font-light" style={{
            color: '#debdc8'
          }} data-id="element-78">
              Y la motivación es inestable.
            </p>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-10 px-4 bg-white" data-id="element-79">
        <div className="max-w-5xl mx-auto" data-id="element-80">
          <div className="text-center mb-8" data-id="element-81">
            <p className="text-gray-500 uppercase tracking-widest font-bold mb-2 text-sm" data-id="element-82">
              Es por eso que creamos
            </p>
            <h2 className="text-5xl md:text-7xl font-black font-heading mb-4" style={{
            color: '#7B4F3A'
          }} data-id="element-83">
              "SALÍ DEL 99%"
            </h2>
            <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto" data-id="element-84">
              Un recorrido de 7 etapas diseñado para dejar de procrastinar y
              empezar a construir tu mejor versión con estructura real en menos
              de 14 días.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-8" data-id="element-85">
            <div data-id="element-86">
              <img src={IMG_MAIN} alt="Sistema Completo" className="w-full rounded-lg shadow-2xl transform rotate-1 hover:rotate-0 transition-all duration-500" data-id="element-87" />
            </div>
            <div data-id="element-88">
              <h3 className="text-2xl font-bold mb-4 border-b-4 inline-block pb-2" style={{
              borderColor: '#debdc8'
            }} data-id="element-89">
                Este sistema te guía para:
              </h3>
              <ul className="space-y-4" data-id="element-90">
                {['Identificar los patrones que te frenan', 'Reordenar tu mentalidad', 'Construir disciplina real', 'Diseñar hábitos alineados', 'Crear dirección personal clara'].map((item, i) => <li key={i} className="flex items-center text-lg" data-id="element-91">
                    <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-92" />
                    <span className="font-medium text-gray-800" data-id="element-93">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-6 p-5 rounded-lg border-l-4" style={{
              backgroundColor: '#f9f0f3',
              borderColor: '#7B4F3A'
            }} data-id="element-94">
                <p className="text-xl font-bold text-gray-900" data-id="element-95">
                  No promete éxito externo. <br data-id="element-96" />
                  <span style={{
                  color: '#7B4F3A'
                }} data-id="element-97">
                    Promete control interno.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-8 px-4" style={{
      backgroundColor: '#debdc8'
    }} data-id="element-98">
        <div className="max-w-4xl mx-auto" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 font-heading text-[#2C1A20]" data-id="element-100">
            📘 ¿Qué incluye exactamente?
          </h2>

          <div className="grid gap-3" data-id="element-101">
            {[{
            title: '7 Guías Digitales Progresivas',
            desc: 'Cada una enfocada en una dimensión clave del desarrollo personal.'
          }, {
            title: 'Ejercicios prácticos en cada etapa',
            desc: 'No es solo lectura: aplicás lo aprendido.'
          }, {
            title: 'Sistema semanal estructurado',
            desc: 'Un modelo simple para organizar tu enfoque y energía.'
          }, {
            title: 'Método anti-procrastinación',
            desc: 'Para ejecutar incluso cuando no tenés ganas.'
          }, {
            title: 'Plan de activación de 21 días',
            desc: 'Para romper la inercia inicial.'
          }].map((item, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm flex items-start border border-white/60" data-id="element-102">
                <div className="p-2 rounded-lg mr-4 flex-shrink-0" style={{
              backgroundColor: 'rgba(123,79,58,0.12)'
            }} data-id="element-103">
                  <Check className="w-5 h-5" style={{
                color: '#7B4F3A'
              }} data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-106">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-107">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-6 text-center" data-id="element-108">
            <p className="text-base font-medium text-[#2C1A20]/70 mb-4" data-id="element-109">
              Formato digital. Descarga inmediata. Acceso de por vida.{' '}
              <span className="text-[#2C1A20] font-bold" data-id="element-110">
                Avanzás a tu ritmo.
              </span>
            </p>
            <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-white text-[#2C1A20] text-xl font-black py-4 px-10 rounded-full shadow-lg transition-all w-full md:w-auto border-2 border-[#2C1A20]/20 hover:-translate-y-1 transform" data-id="element-111">
              👉 QUIERO ACCESO INMEDIATO
            </button>
          </div>
        </div>
      </section>

      {/* First 7 Days */}
      <section className="py-8 px-4 bg-white" data-id="element-112">
        <div className="max-w-3xl mx-auto" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 font-heading text-[#2C1A20]" data-id="element-114">
            Lo que cambia en los primeros 7 días
          </h2>
          <p className="text-center text-gray-500 mb-6" data-id="element-115">
            No es euforia. Es orden mental. Y el orden mental reduce la
            ansiedad.
          </p>

          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#f9f0f3',
          borderColor: '#debdc8'
        }} data-id="element-116">
            <ul className="space-y-4" data-id="element-117">
              {['Detectar con claridad qué te está frenando', 'Tomar una decisión que venías postergando', 'Diseñar una estructura productiva para tu semana', 'Reducir distracciones', 'Sentir dirección nuevamente'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium text-[#2C1A20]" data-id="element-118">
                  <span className="text-2xl font-black" style={{
                color: '#7B4F3A'
              }} data-id="element-119">
                    ✔
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Before vs After — separate section */}
      <section className="py-8 px-4" style={{
      backgroundColor: '#debdc8'
    }} data-id="element-120">
        <div className="max-w-4xl mx-auto" data-id="element-121">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-122">
            {/* Before */}
            <div className="bg-red-50 p-6 rounded-2xl border border-red-100" data-id="element-123">
              <div className="flex items-center mb-4" data-id="element-124">
                <div className="bg-red-500 text-white p-2 rounded-full mr-3" data-id="element-125">
                  <X className="w-5 h-5" data-id="element-126" />
                </div>
                <h3 className="text-2xl font-bold text-red-900" data-id="element-127">Antes</h3>
              </div>
              <ul className="space-y-3" data-id="element-128">
                {['Sensación de estancamiento', 'Procrastinación frecuente', 'Falta de claridad', 'Comparación constante', 'Falta de dirección'].map((item, i) => <li key={i} className="flex items-center text-red-800" data-id="element-129">
                    <span className="w-2 h-2 bg-red-400 rounded-full mr-3 flex-shrink-0" data-id="element-130"></span>
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-green-50 p-6 rounded-2xl border border-green-100 shadow-lg relative overflow-hidden" data-id="element-131">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-132">
                RESULTADO
              </div>
              <div className="flex items-center mb-4" data-id="element-133">
                <div className="bg-green-500 text-white p-2 rounded-full mr-3" data-id="element-134">
                  <Check className="w-5 h-5" data-id="element-135" />
                </div>
                <h3 className="text-2xl font-bold text-green-900" data-id="element-136">Después</h3>
              </div>
              <ul className="space-y-3" data-id="element-137">
                {['Mayor conciencia personal', 'Decisiones más firmes', 'Sistema semanal claro', 'Acción sostenida', 'Sensación de progreso real'].map((item, i) => <li key={i} className="flex items-center text-green-800 font-medium" data-id="element-138">
                    <CheckCircle2 className="w-4 h-4 text-green-600 mr-3 flex-shrink-0" data-id="element-139" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-6" data-id="element-140">
            <p className="text-xl font-medium text-[#2C1A20]" data-id="element-141">
              No cambia tu vida en un día.{' '}
              <span className="font-bold text-2xl" style={{
              color: '#7B4F3A'
            }} data-id="element-142">
                Cambia tu forma de moverte cada día.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-10 px-4" style={{
      backgroundColor: '#2C1A20'
    }} data-id="element-143">
        <div className="max-w-6xl mx-auto" data-id="element-144">
          <div className="text-center mb-8" data-id="element-145">
            <span className="bg-yellow-400 text-black font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-3 inline-block" data-id="element-146">
              GRATIS POR EL DÍA DE HOY
            </span>
            <h2 className="text-4xl md:text-5xl font-black mb-3 font-heading" style={{
            color: '#debdc8'
          }} data-id="element-147">
              🎁 Incluye también estos Bonos Exclusivos
            </h2>
            <p className="text-lg text-white/80" data-id="element-148">
              Estos bonos son completamente{' '}
              <strong className="text-white" data-id="element-149">GRATIS</strong> por el día de hoy
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-150">
            {[{
            img: IMG_BONUS_1,
            label: 'BONO #1',
            title: 'Plan 21 Días – Salida del Piloto Automático',
            desc: 'Acciones concretas para generar movimiento inmediato y romper la inercia.'
          }, {
            img: IMG_BONUS_2,
            label: 'BONO #2',
            title: 'Plantilla de Diseño de Identidad',
            desc: 'Definí quién estás construyendo y bajo qué estándares querés vivir.'
          }, {
            img: IMG_BONUS_3,
            label: 'BONO #3',
            title: 'Vision Board Estratégico',
            desc: 'Convertí deseos difusos en metas claras, medibles y alcanzables.'
          }].map((bonus, i) => <button key={i} onClick={scrollToOffer} className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform block w-full text-left" data-id="element-151">
                <div className="relative" data-id="element-152">
                  <span className="absolute top-3 right-3 bg-yellow-400 text-black text-xs font-black px-3 py-1 rounded-full z-10 uppercase" data-id="element-153">
                    GRATIS
                  </span>
                  <div className="w-full aspect-square overflow-hidden bg-gray-100" data-id="element-154">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-155" />
                  </div>
                </div>
                <div className="p-5" data-id="element-156">
                  <div className="font-bold text-sm mb-1" style={{
                color: '#7B4F3A'
              }} data-id="element-157">
                    {bonus.label}
                  </div>
                  <h3 className="text-lg font-bold mb-2" data-id="element-158">{bonus.title}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-159">{bonus.desc}</p>
                </div>
              </button>)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-10 px-4" style={{
      backgroundColor: '#debdc8'
    }} data-id="element-160">
        <div className="max-w-6xl mx-auto" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 font-heading text-[#2C1A20]" data-id="element-162">
            Lo que dicen quienes ya están aplicando el sistema
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-163">
            {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-white/60 flex flex-col" data-id="element-164">
                <div className="flex items-center mb-3" data-id="element-165">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-166" />)}
                </div>
                <p className="text-gray-700 italic mb-4 flex-grow text-sm" data-id="element-167">
                  "{t.text}"
                </p>
                <div className="flex items-center mt-auto pt-3 border-t border-gray-100" data-id="element-168">
                  <img src={t.image} alt={t.name} className="w-9 h-9 rounded-full object-cover mr-3" data-id="element-169" />
                  <div data-id="element-170">
                    <p className="font-bold text-sm text-gray-900" data-id="element-171">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-172">
                      {t.role}, {t.age}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Offer Stack / Pricing */}
      <section id="compra" className="py-10 px-4 bg-white" data-id="element-173">
        <div className="max-w-3xl mx-auto" data-id="element-174">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2" style={{
          borderColor: '#debdc8'
        }} data-id="element-175">
            <div className="text-white p-5 text-center" style={{
            backgroundColor: '#2C1A20'
          }} data-id="element-176">
              <h3 className="text-2xl font-bold uppercase tracking-wider" data-id="element-177">
                OFERTA ESPECIAL POR TIEMPO LIMITADO
              </h3>
            </div>

            <div className="p-6 md:p-10" data-id="element-178">
              <h2 className="text-3xl md:text-4xl font-black text-center mb-6 font-heading" style={{
              color: '#7B4F3A'
            }} data-id="element-179">
                📦 HOY RECIBÍS
              </h2>

              <div className="space-y-3 mb-8" data-id="element-180">
                {[{
                label: 'Sistema completo SALÍ DEL 99% (7 etapas)',
                value: 'INCLUIDO'
              }, {
                label: 'Plan 21 Días (Bono)',
                value: 'GRATIS'
              }, {
                label: 'Plantilla de Identidad (Bono)',
                value: 'GRATIS'
              }, {
                label: 'Vision Board Estratégico (Bono)',
                value: 'GRATIS'
              }, {
                label: 'Acceso de por vida',
                value: 'INCLUIDO'
              }].map((row, i) => <div key={i} className="flex items-center justify-between border-b border-gray-100 pb-2" data-id="element-181">
                    <span className="text-gray-700 font-medium flex items-center text-sm" data-id="element-182">
                      <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" data-id="element-183" />{' '}
                      {row.label}
                    </span>
                    <span className="font-bold text-gray-900 text-sm ml-2" data-id="element-184">
                      {row.value}
                    </span>
                  </div>)}
              </div>

              <div className="text-center mb-8" data-id="element-185">
                <p className="text-gray-400 text-lg mb-1 line-through" data-id="element-186">
                  Precio regular: ARS $49.990
                </p>
                <p className="text-5xl md:text-6xl font-black mb-3" style={{
                color: '#7B4F3A'
              }} data-id="element-187">
                  ARS $19.990
                </p>
                <p className="text-sm text-gray-500 uppercase tracking-widest font-bold" data-id="element-188">
                  Pago único • Acceso inmediato
                </p>
              </div>

              {/* This is the ONLY button that goes to checkout */}
              <a href={CHECKOUT_URL} className="block w-full text-white text-center text-2xl md:text-3xl font-black py-5 rounded-lg shadow-lg transition-all transform hover:-translate-y-1 animate-pulse-slow mb-4" style={{
              backgroundColor: '#debdc8',
              color: '#2C1A20'
            }} data-id="element-189">
                👉 ACCEDER AHORA
              </a>

              <div className="flex justify-center items-center gap-4 text-sm text-gray-500" data-id="element-190">
                <div className="flex items-center" data-id="element-191">
                  <Lock className="w-4 h-4 mr-1" data-id="element-192" /> Pago Seguro
                </div>
                <div className="flex items-center" data-id="element-193">
                  <CheckCircle2 className="w-4 h-4 mr-1" data-id="element-194" /> Entrega Inmediata
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-8 px-4" style={{
      backgroundColor: '#debdc8'
    }} data-id="element-195">
        <div className="max-w-3xl mx-auto text-center" data-id="element-196">
          <div className="inline-block p-4 rounded-full bg-white/60 mb-4" data-id="element-197">
            <ShieldCheck className="w-14 h-14 text-green-600" data-id="element-198" />
          </div>
          <h2 className="text-3xl font-bold mb-4 font-heading text-[#2C1A20]" data-id="element-199">
            Garantía real, sin riesgo
          </h2>
          <p className="text-xl text-[#2C1A20] mb-3" data-id="element-200">
            Probalo durante <span className="font-bold" data-id="element-201">7 días</span>.
          </p>
          <p className="text-lg text-[#2C1A20]/80 mb-3" data-id="element-202">
            Si no te aporta claridad, estructura y dirección personal, te
            devolvemos el 100% del dinero.
          </p>
          <p className="text-lg font-bold text-[#2C1A20]" data-id="element-203">
            Sin preguntas. Sin vueltas.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-8 px-4 bg-white" data-id="element-204">
        <div className="max-w-3xl mx-auto" data-id="element-205">
          <h2 className="text-3xl font-bold text-center mb-6 font-heading text-[#2C1A20]" data-id="element-206">
            Preguntas frecuentes
          </h2>

          <div className="space-y-3" data-id="element-207">
            {FAQS.map((faq, i) => <div key={i} className="rounded-lg shadow-sm overflow-hidden border" style={{
            borderColor: '#debdc8'
          }} data-id="element-208">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full text-left p-5 flex items-center justify-between bg-white hover:bg-[#fdf5f7] transition-colors" data-id="element-209">
                  <h3 className="text-base font-bold text-gray-900 pr-4" data-id="element-210">
                    {faq.q}
                  </h3>
                  {openFaq === i ? <ChevronUp className="w-5 h-5 flex-shrink-0" style={{
                color: '#7B4F3A'
              }} data-id="element-211" /> : <ChevronDown className="w-5 h-5 flex-shrink-0" style={{
                color: '#7B4F3A'
              }} data-id="element-212" />}
                </button>
                {openFaq === i && <div className="px-5 pb-5 text-gray-600 border-t pt-3" style={{
              borderColor: '#debdc8'
            }} data-id="element-213">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Footer / Closing */}
      <footer className="text-white py-10 px-4 text-center" style={{
      backgroundColor: '#2C1A20'
    }} data-id="element-214">
        <div className="max-w-3xl mx-auto" data-id="element-215">
          <h2 className="text-3xl font-bold mb-5 font-heading" data-id="element-216">Para cerrar</h2>

          <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-217">
            No estás atrasado. No estás roto. No estás condenado al piloto
            automático.
            <br data-id="element-218" />
            <br data-id="element-219" />
            <span className="text-white font-bold" data-id="element-220">
              Pero sí necesitás estructura.
            </span>
          </p>

          <div className="p-6 rounded-xl mb-8 border" style={{
          backgroundColor: 'rgba(222,189,200,0.12)',
          borderColor: 'rgba(222,189,200,0.3)'
        }} data-id="element-221">
            <p className="text-2xl font-bold mb-2" style={{
            color: '#debdc8'
          }} data-id="element-222">
              Sistema SALÍ DEL 99%
            </p>
            <p className="text-lg text-white" data-id="element-223">
              Porque tu vida no se cambia con motivación. <br data-id="element-224" />
              <span className="font-bold underline" data-id="element-225">
                Se cambia con sistema.
              </span>
            </p>
          </div>

          <button onClick={scrollToOffer} className="inline-flex items-center justify-center text-[#2C1A20] text-xl font-black py-4 px-10 rounded-full shadow-lg transition-all hover:-translate-y-1 transform" style={{
          backgroundColor: '#debdc8'
        }} data-id="element-226">
            👉 EMPEZAR A CONSTRUIRME HOY
          </button>

          <p className="mt-8 text-sm text-gray-600" data-id="element-227">
            © 2024 Salí del 99%. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}